import { Box, SxProps, Typography } from "@mui/material";
import { TypographyProps } from "@mui/material/Typography";
import { Macros } from "@notemeal/shared-utils-macro-protocol";
interface MenuBuilderMenuItemMacroProps {
  macros: Macros;
  fontColor?: string;
  variant?: TypographyProps["variant"];
  boxStyle?: SxProps;
}

export const MenuBuilderMenuItemMacro = ({ macros: {cho, pro, fat, kcal}, fontColor, variant = "footnotes", boxStyle  }: MenuBuilderMenuItemMacroProps) => {
  return (
    <Box sx={{ display: "flex", gap: 1, ...boxStyle }}>
      <Typography variant={variant} sx={{ color: fontColor }}>
        {kcal}kcal
        <Typography variant="footnotes" sx={{ ml: 0.5, color: "accents.green.600", display: "inline", fontSize: "inherit" }}>CHO</Typography>: {cho}g
        <Typography variant="footnotes" sx={{ ml: 0.5, color: "accents.blueDark.500", display: "inline", fontSize: "inherit" }}>PRO</Typography>: {pro}g
        <Typography variant="footnotes" sx={{ ml: 0.5, color: "accents.orangeDark.600", display: "inline", fontSize: "inherit" }}>FAT</Typography>: {fat}g
      </Typography>
    </Box>
  );
};